import './App.css';
import './cookie.css';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { useState } from 'react';

import AccessibilityStatementPage from './pages/AccessibilityStatementPage';
import AgeVerificationOverlay from './components/AgeVerificationOverlay'; // ← ekle
import CCPAPrivacyNoticePage from './pages/CCPAPrivacyNoticePage';
import CookieBanner from './components/CookieBanner';
import CookieConsentDialog from './components/CookieConsentDialog';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import HowWeRatePage from './pages/HowWeRatePage';
import PrivacyPage from './pages/PrivacyPage';
import { ROUTES } from './Routes';
import ResponsibleGamblingPage from './pages/ResponsibleGamblingPage';
import ScrollToTop from './components/ScrollToTop';
import TermsPage from './pages/TermsPage';

const App = () => {
  const [ageVerified, setAgeVerified] = useState(false);
  const [isCookieDialogOpen, setIsCookieDialogOpen] = useState(false);

  const toggleCookieDialog = () => {
    setIsCookieDialogOpen(!isCookieDialogOpen);
  };

  return (
    <Router>
      {!ageVerified && (
        <AgeVerificationOverlay onConfirm={() => setAgeVerified(true)} />
      )}
      <ScrollToTop />
      <CookieBanner />
      <CookieConsentDialog toggleCookieDialog={toggleCookieDialog} isCookieDialogOpen={isCookieDialogOpen} />
      <Routes>
        <Route path={ROUTES.BASE} element={<HomePage />} />
        <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPage />} />
        <Route path={ROUTES.TERMS_AND_CONDITIONS} element={<TermsPage />} />
        <Route path={ROUTES.HOW_WE_RATE} element={<HowWeRatePage />} />
        <Route path={ROUTES.RESPOSIBLE_GAMBLING} element={<ResponsibleGamblingPage />} />
        <Route path={ROUTES.ACCESSIBILITY_STATEMENT} element={<AccessibilityStatementPage />} />
        <Route path={ROUTES.CCPA_PRIVACY_NOTICE} element={<CCPAPrivacyNoticePage />} />
      </Routes>
      <Footer toggleCookieDialog={toggleCookieDialog} />
    </Router>
  );
};

export default App;